import React from 'react'
import * as styles from "./Location.module.scss";
import logo from "../../../images/on-going-projects/srinivasa/logo.png";
import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";

function Location() {
  return (
    <>
    <div className={styles.location} id="section-7">
      <div className={styles.heading}>
        <img src={bgImage} alt="Location" className={styles.bgImage} />
        <span>Location</span></div>
      <div className={styles.locationContent}>
        <img src={logo} alt="location-image" className={styles.logo} />
        <iframe className={styles.map}
          title="google map"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3887.070114372418!2d80.224615!3d13.031207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDAxJzUyLjQiTiA4MMKwMTMnMjguNiJF!5e0!3m2!1sen!2sin!4v1757344901558!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        {/* <iframe className={styles.map} src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3887.070114372418!2d80.224615!3d13.031207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDAxJzUyLjQiTiA4MMKwMTMnMjguNiJF!5e0!3m2!1sen!2sin!4v1757344901558!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
      </div>
    </div>
    </>
  )
}

export default Location